import type { CoachingPayment } from "@bw/shared/api";
import { formatMoney, parseDecimal } from "@bw/shared/utils";

/** A payment action requires a price the current response can actually display. */
export function coachingPaymentPrice(payment: Pick<CoachingPayment, "amount" | "currency">): string | null {
  if (parseDecimal(payment.amount) === null || typeof payment.currency !== "string"
      || !/^[A-Za-z]{3}$/.test(payment.currency)) return null;
  const price = formatMoney(payment.amount, payment.currency);
  return price && price !== "—" ? price : null;
}
